const locale = require('./policiesSummary.i18n.json');

/*@ngInject*/
const PoliciesSummaryGridRepository = function (baseRepository, sortUtil, policyStatus, endorsementStatus,
                                                policyRewriteStatus, policyCancellationStatus, policyReinstatementStatus,
                                                currentSubmissionModel) {

    angular.extend(this, baseRepository);
    this.i18n = locale;

        let translationTable = {
            insuredName: ['insured', 'name'],
            assignedUnderwriter: ['assignedUnderwriterSummary', 'name'],
            responsibleUnderwriter: ['responsibleUnderwriterSummary', 'name'],
            number: 'submissionNumber',
            premium: ['totalPremium', 'total'],
            nextAction: ['nextTaskSummary', 'definition'],
            actionDate: ['nextTaskSummary', 'dueDate'],
            quoteNeededByDate: 'quoteNeededByDate'
        },
        sortColumn;



    this.loadPolicies = function (submissionId, submissionParams) {
        let url = '/rest/PolicyChange/List',
            config = {
                params: {
                    submissionId: submissionId,
                    registrationIdentifier: '/SubmissionPolicyChanges/' + submissionId
                }
            };

        currentSubmissionModel.addRegistration({url: url, params: config.params});

        sortColumn = translationTable[submissionParams.key] || submissionParams.key;

        return this.get(url, config).then(function (responseData) {
            let sortedRecords = responseData.sort(sortUtil.naturalSortObject(sortColumn));

            if (submissionParams.sortType === 'desc') {
                sortedRecords.reverse();
            }

            return sortedRecords;
        });
    };

    this.loadPoliciesBySubmissionIds = function (submissionIds, submissionParams) {
        let url = '/rest/Policy/bySubmissionIds',
            config = {
                params: {
                    submissionIds: submissionIds
                }
            };

        if (submissionParams) {
            sortColumn = translationTable[submissionParams.key] || submissionParams.key;
        }

        return this.get(url, config).then(function (responseData) {
            let sortedRecords = responseData;

            if (submissionParams) {
                sortedRecords = responseData.sort(sortUtil.naturalSortObject(sortColumn));

                if (submissionParams.sortType === 'desc') {
                    sortedRecords.reverse();
                }
            }

            return sortedRecords;
        });
    };

    this.processGetResponseData = function (responseData) {

        _.each(responseData, (record) => {
            if (_.includes(record.uri, 'PolicyIssuanceSummary')) {
                switch (record.status) {
                    case policyStatus.BOUND:
                        record.status = this.i18n.policyStatuses.bound;
                        break;
                    case policyStatus.BEGIN_ISSUANCE:
                        record.status = this.i18n.policyStatuses.beginIssuance;
                        break;
                    case policyStatus.PENDING_ISSUANCE:
                        record.status = this.i18n.policyStatuses.pendingIssuance;
                        break;
                    case policyStatus.ISSUED:
                        record.status = this.i18n.policyStatuses.issued;
                        break;
                }
            } else if (_.includes(record.uri, 'EndorsementSummary')) {
                switch (record.status) {
                    case endorsementStatus.INVALID:
                        record.status = this.i18n.endorsementStatuses.invalid;
                        break;
                    case endorsementStatus.DRAFT:
                        record.status = this.i18n.endorsementStatuses.draft;
                        break;
                    case endorsementStatus.SUBMITTED:
                        record.status = this.i18n.endorsementStatuses.submitted;
                        break;
                    case endorsementStatus.DECLINED:
                        record.status = this.i18n.endorsementStatuses.declined;
                        break;
                    case endorsementStatus.PENDING_ISSUANCE:
                        record.status = this.i18n.endorsementStatuses.pendingIssuance;
                        break;
                    case endorsementStatus.ISSUED:
                        record.status = this.i18n.endorsementStatuses.issued;
                        break;
                }
            } else if (_.includes(record.uri, 'PolicyRewriteSummary')) {
                switch (record.status) {
                    case policyRewriteStatus.INVALID:
                        record.status = this.i18n.policyRewriteStatuses.invalid;
                        break;
                    case policyRewriteStatus.DRAFT:
                        record.status = this.i18n.policyRewriteStatuses.draft;
                        break;
                    case policyRewriteStatus.SUBMITTED:
                    case policyRewriteStatus.INVALID_RATING:
                    case policyRewriteStatus.VALID_RATING:
                    case policyRewriteStatus.VALID_PRICING:
                        record.status = this.i18n.policyRewriteStatuses.submitted;
                        break;
                    case policyRewriteStatus.PENDING_ISSUANCE:
                        record.status = this.i18n.policyRewriteStatuses.pendingIssuance;
                        break;
                    case policyRewriteStatus.ISSUED:
                        record.status = this.i18n.policyRewriteStatuses.issued;
                        break;
                }
            } else if (_.includes(record.uri, 'PolicyCancellationSummary')) {
                switch (record.status) {
                    case policyCancellationStatus.REQUESTED:
                        record.status = this.i18n.policyCancellationStatuses.requested;
                        break;
                    case policyCancellationStatus.PENDING:
                        record.status = this.i18n.policyCancellationStatuses.pending;
                        break;
                    case policyCancellationStatus.CANCELLED:
                        record.status = this.i18n.policyCancellationStatuses.cancelled;
                        break;
                    case policyCancellationStatus.RETRACTED:
                        record.status = this.i18n.policyCancellationStatuses.retracted;
                        break;
                    case policyCancellationStatus.RESCINDED:
                        record.status = this.i18n.policyCancellationStatuses.rescinded;
                        break;
                    case policyCancellationStatus.INVALID:
                        record.status = this.i18n.policyCancellationStatuses.invalid;
                        break;
                }
            } else if (_.includes(record.uri, 'PolicyReinstatementSummary')) {
                switch (record.status) {
                    case policyReinstatementStatus.REINSTATED:
                        record.status = this.i18n.policyReinstatementStatuses.reinstated;
                        break;
                    case policyReinstatementStatus.INVALID:
                        record.status = this.i18n.policyReinstatementStatuses.invalid;
                        break;
                }
            } else {
                record.status = '--';
            }
        });

        return responseData;
    };
}
;

angular.module('gw-um-submission')
    .service('policiesSummaryGridRepository', PoliciesSummaryGridRepository);
